import './app.scss'

import React, { Component } from 'react';
import Config from './config';
import { Switch, Route, Redirect, Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import Landing from './states/landing';
import ThankYou from './states/thank-you';
import Google from './states/google';
import Facebook from './states/facebook';
import BadTimes from './states/bad-times';
import BadTimesThankYou from './states/bad-times-thanks';
import gql from 'nanogql';

import 'whatwg-fetch';


const history = createBrowserHistory();
const initGA = (history) => {
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

  ga('create', 'UA-90741411-23', 'auto');
  ga('send', 'pageview');

  history.listen((location) => {
    const path = location.pathname.replace(/^\/([^\/]+)\/[^\/]+\/?/, '/$1/');
    console.log("tracking page view: " + path);
    ga('send', 'pageview', path);
  });
};

initGA(history);

class App extends Component {

  state = {
    headerImage: '',
    logo: '',
    logoMobile: '',
    loading: true
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    return this.fetchSettings()
      .catch((error) => {
        console.warn(error);
        alert('Unable to load');
      });
  }

  async fetchSettings() {
    const query = gql`
      query Query($domain: String!) {
          getDomainPortalSettings(domain: $domain) {
              _id,
              email,
              name,
              facebookReviewLink,
              googleReviewLink,
              headerImage,
              logo,
              website,
              directorInfo,
              groups {
                  facebookReviewLink,
                  googleReviewLink,
                  name,
                  disabled
              }
          }
      }
    `;

    const response = await fetch('https://api.reviews.nzdigital.co.nz/graphql', {
      method: 'POST',
      body: JSON.stringify(query({
        domain: location.host
      })),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const json = await response.json();

    if (!(json && json.data && json.data.getDomainPortalSettings)) {
      alert('Unabled to load settings');
      return;
    }

    Config.setConfig(json.data.getDomainPortalSettings);

    return new Promise((resolve) => this.setState({
      loading: false,
      config: json.data.getDomainPortalSettings,
      headerImage: Config.getHeaderImage(),
      logo: Config.getLogo(),
      logoMobile: Config.getLogoMobile(),
    }));
  }

  render() {
    return (
      <Router history={history}>
        {
          this.state.loading ? (
            <div className="cs-loader">
              <div className="cs-loader-inner">
                <label>	●</label>
                <label>	●</label>
                <label>	●</label>
                <label>	●</label>
                <label>	●</label>
                <label>	●</label>
              </div>
            </div>
          ) : (
            <div className="app">
              <style type="text/css">
                {`
                  .app:before {
                    background-image:url(${this.state.headerImage});
                  }
                `}
              </style>
              <div className="logo-container" style={{ backgroundImage: `url(${this.state.headerImage})`}}>
                <div className="logo-inner-container">
                  <img src={this.state.logo} className="desktop" />
                  <img src={this.state.logoMobile} className="mobile" />
                </div>
              </div>
              <div className="content-container">
                <Switch>
                  <Route path="/:group/:key" exact component={Landing} />
                  <Route path="/:group/:key/thank-you" exact component={ThankYou} />
                  <Route path="/:group/:key/thank-you/google" exact component={Google} />
                  <Route path="/:group/:key/thank-you/facebook" exact component={Facebook} />
                  <Route path="/:group/:key/feedback" exact component={BadTimes} />
                  <Route path="/:group/:key/feedback/thank-you" exact component={BadTimesThankYou} />
                  <Redirect to="/default/none" />
                </Switch>
              </div>
            </div>
          )
        }
      </Router>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/app.js